import {ProductVariant} from '@shopify/hydrogen/storefront-api-types';
import {PartialDeep} from 'type-fest/source/partial-deep';
import {getIsP2PVariant, getShopifyProductVariantMetafields} from './variants';

export function getVariantCartAttributes(
  variant: PartialDeep<Partial<ProductVariant>> | undefined,
): {
  key: string;
  value: string;
}[] {
  if (variant && getIsP2PVariant(variant as ProductVariant)) {
    const metafields = getShopifyProductVariantMetafields(variant.metafields);
    return [
      {
        key: '_p2pSellerEmail',
        value: metafields.sellerEmail || 'Seller email metafield was not set',
      },
      {
        key: '_collectedProductUuid',
        value:
          metafields.collectedProductUuid ||
          'Collected product UUID metafield was not set',
      },
    ];
  }
  return [];
}
